import { setOption, subscribeToOption } from "../../Utilities/Platform/Options/Options";
import { Bootstrapper } from "../Bootstrapper";

export class CloseDetectionBootstrapper extends Bootstrapper {
    protected static skipForceClose = false;

    public static ignoreForceClose(): void {
        CloseDetectionBootstrapper.skipForceClose = true;
    }

    /**
     * @inheritDoc
     */
    public bootstrap(): void {
        setOption("_force_close", false);

        subscribeToOption("_force_close", (_, newValue) => {
            if(CloseDetectionBootstrapper.skipForceClose) {
                return;
            }

            if(newValue) {
                console.log("Received notification from another page to close");

                window.close();
            }
        });
    }
}
